import { render } from "./pop-up-menu.vue?vue&type=template&id=6206bc56"
import script from "./pop-up-menu.vue?vue&type=script&lang=js"
export * from "./pop-up-menu.vue?vue&type=script&lang=js"

import "./pop-up-menu.vue?vue&type=style&index=0&id=6206bc56&lang=css"

import exportComponent from "C:\\Programming\\padma_erp\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__